<template>
  <custom-dialog width="500px" :title="model.title" :visible="visible" v-on="$listeners" :append-to-body="true" class="msg-filter-dialog">
    <div class="dialog-body">
      <el-form :model="form" ref="form" label-position="top">
        <el-form-item :label="$t('msg_filter_dialog.xiao_xi_lei_bie')">
          <custom-select :auto="false" :data="msgTypeList" :props="{ label: 'name', value: 'value' }" v-model="form.msgType"></custom-select>
        </el-form-item>
        <el-form-item :label="$t('Common.com_time')">
          <custom-date-picker style="width: 100%" :clearable="false" v-model="form.sendTime" type="daterange" :init-value="initValue" value-format="YYYY-MM-DD HH:mm:ss"></custom-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    msgTypeList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      form: {
        msgType: '',
        sendTime: '',
      },
      initValue: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onConfirm() {
      this.$emit('confirm', this.form);
      this.visible = false;
    },
    init() {
      this.$setFormatData(this.form, this.model.data);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
